import { ApplicantAnswersReviewLandingPage } from './LandingPage';
import { WizardProvider } from '../../../components/wizard/useWizard';
import {
	ApplicantAnswersReviewProvider,
	useApplicantAnswersReview,
} from './useApplicantAnswersReview';

export const AnswersReviewContext = () => {
	const { application } = useApplicantAnswersReview();
	const { applicant } = application;
	return (
		<div className="flex flex-col h-full min-h-0 p-[8px]">
			<ApplicantAnswersReviewLandingPage applicantInfo={applicant} />,
		</div>
	);
};

export const AnswersReviewContextWizardContainer = () => {
	return (
		<ApplicantAnswersReviewProvider>
			<WizardProvider>
				<AnswersReviewContext />
			</WizardProvider>
		</ApplicantAnswersReviewProvider>
	);
};
